/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { get } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";
import FormInputCheckbox from "components/forms/form-checkbox";

const ConfigureDisableTimeFilter = () => {
  const { report, editReport } = useReportBuilder();

  const value = !!get(report, "config.applyDateRangeFilter", true);
  const normalizedValue = value === false ? false : true;

  const handleChange = (e) => {
    editReport({
      config: {
        applyDateRangeFilter: !normalizedValue,
      },
    });
  };

  return (
    <Box>
      <FormInputCheckbox
        onChange={handleChange}
        label="Apply date range filter"
        checked={normalizedValue}
      />
    </Box>
  );
};

export default ConfigureDisableTimeFilter;
